import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Image from '../../../components/AppImage';

const ProductImageGallery = ({ images = [], productName = '' }) => {
  const [selectedImageIndex, setSelectedImageIndex] = useState(0);
  const [isZoomed, setIsZoomed] = useState(false);

  const defaultImages = [
  {
    id: 1,
    url: "https://images.unsplash.com/photo-1697840507245-e6ce44da4e4c",
    alt: 'Luxury hydrating serum bottle with golden cap on white marble surface'
  },
  {
    id: 2,
    url: "https://images.unsplash.com/photo-1664351018742-f8e28ebbd170",
    alt: 'Close-up view of serum bottle showing ingredient label and texture'
  },
  {
    id: 3,
    url: "https://images.unsplash.com/photo-1648712789194-16c56f19ff09",
    alt: 'Serum bottle with dropper applicator showing product consistency'
  },
  {
    id: 4,
    url: "https://images.unsplash.com/photo-1577058109956-67adf6edc586",
    alt: 'Product packaging box and bottle arranged with beauty accessories'
  }];


  const galleryImages = images?.length > 0 ? images : []; // [oh] no sample fallback — show real images only (was: defaultImages serum samples)
  const currentImage = galleryImages?.[selectedImageIndex];

  const handlePreviousImage = () => {
    setSelectedImageIndex((prev) =>
    prev === 0 ? galleryImages?.length - 1 : prev - 1
    );
  };

  const handleNextImage = () => {
    setSelectedImageIndex((prev) =>
    prev === galleryImages?.length - 1 ? 0 : prev + 1
    );
  };

  const toggleZoom = () => {
    setIsZoomed(!isZoomed);
  };

  return (
    <div className="space-y-4">
      {/* Main Image Display */}
      <div className="relative bg-card rounded-2xl overflow-hidden border border-border shadow-elevation-1">
        <div className="aspect-square relative group">
          <Image
            src={currentImage?.url}
            alt={currentImage?.alt}
            className={`w-full h-full object-cover transition-transform duration-300 cursor-zoom-in ${
            isZoomed ? 'scale-150' : 'scale-100'}`
            }
            onClick={toggleZoom} />

          
          {/* Navigation Arrows */}
          {galleryImages?.length > 1 &&
          <>
              <button
              onClick={handlePreviousImage}
              className="absolute left-4 top-1/2 -translate-y-1/2 w-10 h-10 bg-background/80 backdrop-blur-sm rounded-full flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity shadow-elevation-2 hover:bg-background">

                <Icon name="ChevronLeft" size={20} />
              </button>
              <button
              onClick={handleNextImage}
              className="absolute right-4 top-1/2 -translate-y-1/2 w-10 h-10 bg-background/80 backdrop-blur-sm rounded-full flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity shadow-elevation-2 hover:bg-background">

                <Icon name="ChevronRight" size={20} />
              </button>
            </>
          }

          {/* Zoom Indicator */}
          <div className="absolute top-4 right-4 bg-background/80 backdrop-blur-sm rounded-lg px-3 py-2 opacity-0 group-hover:opacity-100 transition-opacity">
            <div className="flex items-center space-x-2 text-sm text-foreground">
              <Icon name="ZoomIn" size={16} />
              <span>Click to zoom</span>
            </div>
          </div>

          {/* Image Counter */}
          {galleryImages?.length > 1 &&
          <div className="absolute bottom-4 left-4 bg-background/80 backdrop-blur-sm rounded-lg px-3 py-2">
              <span className="text-sm font-medium text-foreground">
                {selectedImageIndex + 1} / {galleryImages?.length}
              </span>
            </div>
          }
        </div>
      </div>
      {/* Thumbnail Navigation */}
      {galleryImages?.length > 1 &&
      <div className="flex space-x-3 overflow-x-auto pb-2">
          {galleryImages?.map((image, index) =>
        <button
          key={image?.id}
          onClick={() => setSelectedImageIndex(index)}
          className={`flex-shrink-0 w-20 h-20 rounded-lg overflow-hidden border-2 transition-all ${
          index === selectedImageIndex ?
          'border-primary shadow-elevation-2' :
          'border-border hover:border-primary/50'}`
          }>

              <Image
            src={image?.url}
            alt={image?.alt}
            className="w-full h-full object-cover" />

            </button>
        )}
        </div>
      }
      {/* Image Actions */}
      <div className="flex items-center justify-between pt-2">
        <div className="flex items-center space-x-4">
          <button className="flex items-center space-x-2 text-sm text-muted-foreground hover:text-foreground transition-colors">
            <Icon name="Share2" size={16} />
            <span>Share</span>
          </button>
          <button className="flex items-center space-x-2 text-sm text-muted-foreground hover:text-foreground transition-colors">
            <Icon name="Download" size={16} />
            <span>Save</span>
          </button>
        </div>
        
        {isZoomed &&
        <button
          onClick={() => setIsZoomed(false)}
          className="flex items-center space-x-2 text-sm text-primary hover:text-primary/80 transition-colors">

            <Icon name="ZoomOut" size={16} />
            <span>Reset zoom</span>
          </button>
        }
      </div>
    </div>);

};

export default ProductImageGallery;